import { jsx as _jsx } from "react/jsx-runtime";
import { startTransition } from 'react';
import { setUserLanguage } from '@helsenorge/framework-utils/hn-language';
import { languageChanged, selectLanguages } from '@helsenorge/framework-utils/language';
import useLanguageEvent from './useLanguageEvent';
import LanguagePicker from '../language-picker';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import styles from './styles.module.scss';
const LanguagePickerOriginName = 'LanguagePicker';
export const LanguagePickerWrapper = () => {
    const dispatch = useAppDispatch();
    const languages = useAppSelector(state => selectLanguages(state.language));
    const handleLanguageChange = (newLanguage) => {
        setUserLanguage(newLanguage, { origin: LanguagePickerOriginName });
        startTransition(() => {
            dispatch(languageChanged(newLanguage));
        });
    };
    useLanguageEvent(options => options?.origin !== LanguagePickerOriginName);
    if (languages.length <= 1) {
        return null;
    }
    return (_jsx("div", { className: "container", children: _jsx("div", { className: "row", children: _jsx("div", { className: "col", children: _jsx("div", { className: styles['language-picker-wrapper'], children: _jsx(LanguagePicker, { languages: languages, onLanguageChange: handleLanguageChange, testId: "language-picker" }) }) }) }) }));
};
export default LanguagePickerWrapper;
